import API from "../index";
import { API_GET_INSPECTION_DETAILS } from "../../constants/api";

export async function fetchInspectionDetails(id, workflowId) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    const response = await API.get(
      API_GET_INSPECTION_DETAILS + "/" + id + "/" + workflowId,
      {},
      { headers }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
}
